/* ============================================================
 * PlayAh VN Address Persist v1.0 (2026-07-22)
 * Bổ sung cho playah-vn-addr.js (VN-ADDRESS v3.x) — KHÔNG sửa file gốc.
 *
 * Vấn đề fix:
 *  - restoreFromCart() của v3 chỉ restore vn_full_name / vn_phone /
 *    vn_email / vn_address_detail / vn_note từ cart attributes,
 *    KHÔNG restore vn_province_code / vn_district_code / vn_ward_code
 *    (dù submit có lưu đủ) → Tỉnh/Quận/Xã luôn trống khi quay lại.
 *  - Cart attributes mất khi cart reset (sau khi mua xong / hết hạn)
 *    → thêm lớp localStorage 90 ngày làm dự phòng.
 *  - Ô địa chỉ chi tiết thiếu autocomplete="street-address".
 * ============================================================ */
(function () {
  var LS_KEY = 'playah_vn_addr_v1';
  var TTL_DAYS = 90;

  function $(s) { return document.querySelector(s); }
  function getFields() {
    return {
      name: $('input[name="full_name"]'),
      phone: $('input[name="phone"]'),
      email: $('input[name="email"]'),
      province: document.getElementById('playah-vn-province'),
      district: document.getElementById('playah-vn-district'),
      ward: document.getElementById('playah-vn-ward'),
      address: $('input[name="address_detail"]'),
      note: $('textarea[name="note"]')
    };
  }

  function readLS() {
    try {
      var o = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (!o) return null;
      if (Date.now() - (o.ts || 0) > TTL_DAYS * 864e5) {
        localStorage.removeItem(LS_KEY);
        return null;
      }
      return o;
    } catch (e) { return null; }
  }

  function writeLS(f) {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({
        ts: Date.now(),
        full_name: (f.name && f.name.value) || '',
        phone: (f.phone && f.phone.value) || '',
        email: (f.email && f.email.value) || '',
        province_code: (f.province && f.province.value) || '',
        district_code: (f.district && f.district.value) || '',
        ward_code: (f.ward && f.ward.value) || '',
        address_detail: (f.address && f.address.value) || '',
        note: (f.note && f.note.value) || ''
      }));
    } catch (e) { /* private mode / quota — bỏ qua */ }
  }

  function setIfEmpty(el, v) { if (el && v && !el.value) el.value = v; }

  function fire(el) { el.dispatchEvent(new Event('change', { bubbles: true })); }

  /* Chờ select được nạp option có value = code (tối đa ~4s) */
  function waitOptions(sel, code) {
    return new Promise(function (res) {
      var n = 0;
      (function poll() {
        if (sel && !sel.disabled && sel.querySelector('option[value="' + code + '"]')) return res(true);
        if (++n > 40) return res(false);
        setTimeout(poll, 100);
      })();
    });
  }

  function restoreCascade(f, pc, dc, wc) {
    if (!pc || !f.province || f.province.value) return Promise.resolve(); /* user đã tự chọn → không đụng */
    if (!f.province.querySelector('option[value="' + pc + '"]')) return Promise.resolve(); /* code lỗi thời */
    f.province.value = pc; fire(f.province);
    if (!dc) return Promise.resolve();
    return waitOptions(f.district, dc).then(function (ok) {
      if (!ok) return;
      f.district.value = dc; fire(f.district);
      if (!wc) return;
      return waitOptions(f.ward, wc).then(function (ok2) {
        if (!ok2) return;
        f.ward.value = wc; fire(f.ward);
      });
    });
  }

  var ran = false;
  function run() {
    if (ran) return; ran = true;
    var f = getFields();
    if (!f.province) return; /* không phải trang cart */

    /* autocomplete chuẩn → browser có thể gợi ý địa chỉ từng nhập ở web khác */
    if (f.address && !f.address.getAttribute('autocomplete')) {
      f.address.setAttribute('autocomplete', 'street-address');
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { return (cart && cart.attributes) || {}; })
      .catch(function () { return {}; })
      .then(function (a) {
        var ls = readLS() || {};
        setIfEmpty(f.name, a.vn_full_name || ls.full_name);
        setIfEmpty(f.phone, a.vn_phone || ls.phone);
        setIfEmpty(f.email, a.vn_email || ls.email);
        setIfEmpty(f.address, a.vn_address_detail || ls.address_detail);
        setIfEmpty(f.note, a.vn_note || ls.note);
        return restoreCascade(
          f,
          a.vn_province_code || ls.province_code,
          a.vn_district_code || ls.district_code,
          a.vn_ward_code || ls.ward_code
        );
      })
      .then(function () { writeLS(getFields()); });

    /* Lưu mỗi khi user đổi bất kỳ field nào của form */
    var WATCH = { full_name: 1, phone: 1, email: 1, province: 1, district: 1, ward: 1, address_detail: 1, note: 1 };
    ['change', 'blur'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target && WATCH[e.target.name]) writeLS(getFields());
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
